module.exports = __webpack_public_path__ + "static/media/1_MACDONALDS.ebbcf407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_mcdonalds/1_MACDONALDS.jpg
// module id = 334
// module chunks = 37